import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import NodeArticleTeaser from './Teaser';
import NodeArticlePage from './Page';
import { NodeArticle } from '../../../types/uncinc_profile/nodes';
import NodeArticleHighlighted from './Highlighted';

interface NodeArticleProps {
  entity: ImmutableEntity<NodeArticle>;
  viewMode: string;
  classes: string;
}

const NodeArticleWrapper: React.FC<NodeArticleProps> = ({ entity, viewMode, classes = '' }) => {
  switch (viewMode) {
    case 'teaser':
      return <NodeArticleTeaser entity={entity} classes={classes} />;
    case 'highlighted':
      return <NodeArticleHighlighted entity={entity} />;
    default:
      return <NodeArticlePage entity={entity} />;
  }
};

export default NodeArticleWrapper;
